import { render, staticRenderFns } from "./basic-chart.vue?vue&type=template&id=44fa20f7&scoped=true&"
import script from "./basic-chart.vue?vue&type=script&lang=js&"
export * from "./basic-chart.vue?vue&type=script&lang=js&"
import style0 from "./basic-chart.vue?vue&type=style&index=0&id=44fa20f7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fa20f7",
  null
  
)

export default component.exports